import { UPDATE_SERVICE_GET_AVAILABLE_UPDATES_URL, UPDATE_SERVICE_REQUEST_UPDATE_URL } from './config';
import { getHeaders } from './fetch';

let productInstanceAvailableUpdates = null,
  productInstanceAvailableUpdatesFetched = null;

export async function getProductInstanceAvailableUpdate() {
  if (productInstanceAvailableUpdatesFetched && (Date.now() - productInstanceAvailableUpdatesFetched) < 60000) {
    return productInstanceAvailableUpdates;
  }
  const response = await fetch(
    UPDATE_SERVICE_GET_AVAILABLE_UPDATES_URL,
    {
      method: 'GET',
      headers: {
        ...getHeaders(),
        'Accept': 'application/json'
      }
    }
  );
  productInstanceAvailableUpdates = await response.json();
  productInstanceAvailableUpdatesFetched = Date.now();
  return productInstanceAvailableUpdates;
}


export async function requestUpdate(productUuid) {
  const response = await fetch(
    `${UPDATE_SERVICE_REQUEST_UPDATE_URL}/${productUuid}`,
    {
      method: 'GET',
      headers: {
        ...getHeaders(),
        'Accept': 'application/json'
      }
    }
  );
  if (response.ok) {
    return null;
  }
  throw new Error('Response did not contain a 200-299 response code');
}


// WEBPACK FOOTER //
// ./src/services/update-service.js